import copyHandler from './copyHandler';
import pasteHandler from './pasteHandler';

function removeCopyPasteListeners() {
  document.removeEventListener('copy', copyHandler);
  document.removeEventListener('paste', pasteHandler);
}

export default removeCopyPasteListeners;
